/**
 * 纹理的过滤模式。
 */
export enum FilterMode {
    /**点过滤。*/
    Point = 0,
    /**双线性过滤。*/
    Bilinear = 1,
    /**三线性过滤。*/
    Trilinear = 2,
}